import { Inbox } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/** Icon + title + subtitle empty state, optionally with one action button. */
export function EmptyState({ icon: Icon = Inbox, title, subtitle, action }: {
  icon?: LucideIcon;
  title: string;
  subtitle?: string;
  action?: { label: string; onClick: () => void };
}) {
  return (
    <div className="flex flex-col items-center justify-center py-10 px-4 text-center">
      <div className="w-10 h-10 rounded-full bg-bg-hover flex items-center justify-center mb-3">
        <Icon size={18} className="text-muted" />
      </div>
      <p className="text-sm font-medium text-white">{title}</p>
      {subtitle && <p className="text-xs text-muted mt-1 max-w-sm">{subtitle}</p>}
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          className="mt-3 text-xs bg-accent hover:bg-emerald-400 text-accent-fg font-medium px-3 py-1.5 rounded-lg"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
